export const MIN_TOUR_PRICE = 2;
export const MAX_TOUR_PRICE = 99;

export const TOUR_ICON_ALLOWED_TYPES = ["image/png", "image/jpeg"];
export const TOUR_ICON_MAX_BYTES = 500 * 1024;
export const TOUR_ICON_RECOMMENDED_SIZE = 256;

// Longueur du HTML transmis au back, balisage compris.
export const MAX_BUYER_EMAIL_TEXT_LENGTH = 5000;

export const DEFAULT_TAX_PERCENTAGE = 20;
export const MIN_TAX_PERCENTAGE = 0;
export const MAX_TAX_PERCENTAGE = 30;

// Le back accepte n'importe quel code pays ; on borne à ceux qu'on sait
// pertinents pour les vendeurs afin d'éviter les saisies libres fantaisistes.
export const TAX_COUNTRIES = [
  "FR",
  "BE",
  "CH",
  "LU",
  "DE",
  "ES",
  "IT",
  "PT",
  "NL",
  "IE",
  "AT",
  "GB",
];
